import _get from 'lodash/get';

export const getRouterState = state => state.router;
export const getRouterLocation = state => _get(getRouterState(state), 'location');
export const getRouterPathname = state => _get(getRouterLocation(state), 'pathname');
export const getRouterSearch = state => _get(getRouterLocation(state), 'search');
export const getRouterQuery = state => _get(getRouterLocation(state), 'query');